import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/scheme/SchemeContent.tsx");
;
import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/cs-mobile-next/styles/category/index.module.scss");
